import { useBaseMutation } from '../components/hooks/useBaseMutation';

export const useJoinCart = () => {
  return useBaseMutation(
    'put',
    'https://api.menufy.link/restaurantBackend/stores/cartSession')
}

